import React from "react";

const InputForm = ({
  label,
  type = "text",
  id,
  name,
  value,
  onChange,
  placeholder = "",
  className = "",
  min,
  step,
  required = false,
}) => (
  <div className="flex items-center justify-center gap-3 w-full">
    <label htmlFor={id} className="sm:w-44 w-32 text-left font-medium text-gray-700 text-base">
      {label}
    </label>
    <input
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`input-field flex-1 w-full max-w-[400px] ${className}`}
      min={min}
      step={step}
      required={required}
    />
  </div>
);

export default InputForm;